import { dialogDefault, DIALOG_LOGIN } from "../consts";

const mydialog = {...dialogDefault}

export const dialogLogin = info => ({
    type: DIALOG_LOGIN,
    payload: info
});

export default function loginDialogReducer(state = mydialog, { type, payload }) {
    const actions = {
        [DIALOG_LOGIN] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}